import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHyphen } from "@fortawesome/pro-solid-svg-icons";
import "./DateRangePickerLogs.scss";

interface IProps {
    startDate: Date;
    endDate: Date;
    onChangeStart: Function;
    onChangeEnd: Function;
}

function DateRangePickerLogs(props: IProps) {
    return (
        <div className="dateRangePickerLogs">
            <DatePicker
                selected={props.startDate}
                onChange={(date: any) => {
                    props.onChangeStart(date);
                }}
                timeInputLabel="Time:"
                dateFormat=" EEE, MMM dd, yyyy"
                className="customDatePickerLogs"
                maxDate={props.endDate}
            />
            <div className="dateRangeIcon">
                <FontAwesomeIcon icon={faHyphen} className="dateRangeSeparator" />
            </div>
            <DatePicker
                selected={props.endDate}
                onChange={(date: any) => {
                    props.onChangeEnd(date);
                }}
                timeInputLabel="Time:"
                dateFormat=" EEE, MMM dd, yyyy"
                className="customDatePickerLogs"
                maxDate={new Date(new Date().getTime() + 86400000)} // extra day to account for timezone differences
                minDate={props.startDate}
            />
        </div>
    );
}

export default DateRangePickerLogs;
